import AdresseCodePostal from '@/generated/controls/adresse/AdresseCodePostal.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: AdresseCodePostal
})
